import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { UpgradeIds } from "../config/upgrades";
import TileEntity from "../TileEntity";

class StoneQuarryBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.STONE_QUARRY;

	public get consumption(): Map<ResourceType, number> {
		const consumption = new Map<ResourceType, number>(super.consumption);
		let populationConsumption =
			(consumption.get(ResourceType.POPULATION_CONSUMPTION) as number) ||
			0;
		populationConsumption -= getUpgradeCurrentReplaceValueById(
			UpgradeIds.wooden_wedges,
		);
		consumption.set(
			ResourceType.POPULATION_CONSUMPTION,
			populationConsumption,
		);

		return consumption;
	}
}

export default StoneQuarryBuildingTileEntity;
